import { render } from "./DepartmentAdd.vue?vue&type=template&id=65cc1898&scoped=true"
import script from "./DepartmentAdd.vue?vue&type=script&lang=js"
export * from "./DepartmentAdd.vue?vue&type=script&lang=js"

import "./DepartmentAdd.vue?vue&type=style&index=0&id=65cc1898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cc1898"]])

export default __exports__